<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="screenDetail" class="container py-3">
  <div class="row justify-content-center">
    <h1 class="lifedi-color mb-5">
      คำถามคัดกรอง
    </h1>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-8">

      <div [formGroup]="consentForm">
        <div *ngFor="let item of screenChoice">
          <lifedi-research-choice [consentForm]="consentForm" [consentDetail]="item"></lifedi-research-choice>
        </div>
      </div>

      <div class="row justify-content-center mt-3 py-3">
        <button class="btn btn-success mr-3" (click)="send(consentForm.value)" style="color: #FFF; width: 100px;">
          ส่งคำตอบ
        </button>
      </div>

    </div>
  </div>
</div>
